import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const TimerIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.42426 10.0758C9.18995 9.84145 8.81005 9.84145 8.57574 10.0758C8.34142 10.3101 8.34142 10.69 8.57574 10.9243L11.5757 13.9243C11.8101 14.1586 12.1899 14.1586 12.4243 13.9243C12.6586 13.69 12.6586 13.3101 12.4243 13.0758L9.42426 10.0758Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.4 2.6C9.4 2.26863 9.66863 2 10 2H14C14.3314 2 14.6 2.26863 14.6 2.6C14.6 2.93137 14.3314 3.2 14 3.2H12.6V5.02087C14.4959 5.15309 16.2205 5.90706 17.5712 7.08025L18.1515 6.50004L17.9757 6.3243C17.7414 6.08998 17.7414 5.71008 17.9757 5.47578C18.2101 5.24147 18.59 5.24147 18.8243 5.47579L20.0243 6.67584C20.2586 6.91016 20.2586 7.29006 20.0242 7.52437C19.7899 7.75868 19.41 7.75867 19.1757 7.52435L19 7.34859L18.4198 7.92878C19.7156 9.4207 20.5 11.3688 20.5 13.5C20.5 18.1944 16.6944 22 12 22C7.30558 22 3.5 18.1944 3.5 13.5C3.5 9.00732 6.98556 5.32872 11.4 5.02087V3.2H10C9.66863 3.2 9.4 2.93137 9.4 2.6ZM19.3 13.5C19.3 17.5317 16.0317 20.8 12 20.8C7.96832 20.8 4.7 17.5317 4.7 13.5C4.7 9.46835 7.96832 6.20002 12 6.20002C16.0317 6.20002 19.3 9.46835 19.3 13.5Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

TimerIcon.propTypes = iconPropTypes;
TimerIcon.defaultProps = iconDefaultProps;
